import { createSlice } from "@reduxjs/toolkit";

const initialDismantleCategoryState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  meta: { total: 0 },
  links: null,
  lastError: null,
  dismantleCategoryForEdit: undefined,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const dismantleCategorySlice = createSlice({
  name: "dismantleCategory",
  initialState: initialDismantleCategoryState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    dismantleCategoryFetched: (state, action) => {
      const { entities, meta, links } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.meta = meta;
      state.links = links;
    },
    dismantleCategoryAllFetched: (state, action) => {
      const { count, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = count;
    },
    dismantleCategoryCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.dismantleCategory.push(action.payload.dismantleCategory);
    },
    dismantleCategoryDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.dismantleCategory.filter(el => el.dismantle_category_id !== action.payload.id);
    },
    getDismantleCategory: (state, action) => {
      state.actionsLoading = false;
      state.dismantleCategoryForEdit = action.payload.dismantleCategoryForEdit;
      state.error = null;
    },
    // updateProduct
    dismantleCategoryUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities.dismantleCategory = state.entities.dismantleCategory.map(entity => {
        if (entity.dismantle_category_id === action.payload.dismantleCategory.dismantle_category_id) {
          return action.payload.dismantleCategory;
        }
        return entity;
      });
    },
  },
});
